import React from "react";
import { StyleSheet, View, Text } from "react-native-web";
import { BackButton, IconizedTextInput } from "../../../components/atoms";
import { useTranslation } from "react-i18next";
import { Colors, Fonts, Images } from "../../../config";
import Image from "next/image";
import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import { getClass } from "../../../helpers/formatHelpers";

const NavigationSearchView = (props) => {
  const { t } = useTranslation();
  const { isMobileVersion, buttonPropsMenuMore } = props;

  return (
    <View style={styles.container}>
      <View style={styles.searchContainer}>
        <IconizedTextInput
          placeholder={t("key_search")}
          bordered
          onChangeText={(text) => {
            props.setKeyword(text);
          }}
          value={props.keyword}
          maxLength={64}
          autoCapitalize="none"
          autoCorrect={false}
          containerStyle={{
            backgroundColor: getClass("bg-input"),
            borderWidth: 0,
            height: isMobileVersion ? 30 : 40,
            flex: 1,
          }}
          returnKeyType="next"
          showClose={props.keyword !== ""}
          onPressClose={() => props.setKeyword("")}
          isMobileVersion={isMobileVersion}
        />
        <div className="flex justify-center items-center relative">
          <div
            {...buttonPropsMenuMore}
            style={{
              justifyContent: "center",
              alignItems: "center",
              marginLeft: 8,
              display: "flex",
            }}>
            <Image
              src={Images.iconMenuMore}
              width={24}
              height={24}
              layout="fixed"
              alt="more menu"
            />
          </div>
        </div>
      </View>
      <BackButton withoutBG={true} isMobileVersion={isMobileVersion} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderBottomWidth: 1,
    borderBottomColor: getClass("bg-black2"),
    backgroundColor: getClass("header"),
    paddingBottom: 16,
    paddingHorizontal: 12,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  searchContainer: {
    paddingLeft: 46,
    paddingTop: 14,
    flex: 1,
    flexDirection: "row",
  },
});

export default NavigationSearchView;
